// NPM Imports
import React, { Fragment, Component } from "react";
// import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FIELDS } from "../../../../constants";

class FieldsDataHeader extends Component {
  state = {};

  render() {
    let { startDate, endDate } = this.props.syncDataSource;
    if (startDate) {
      const currentStartDate = new Date(startDate).toString();
      startDate = currentStartDate.split(" ").slice(1, 4).join(" ");
    }
    if (endDate) {
      const currentEndDate = new Date(endDate).toString();
      endDate = currentEndDate.split(" ").slice(1, 4).join(" ");
    }
    const dataSource = FIELDS.DATA_SOURCES.find(
      source => source.name === this.props.dataSourceSelected,
    );

    return (
      <Fragment>
        <div className="fields-header-container">
          {/* SEARCH BAR SECTION */}
          <div className="fields-header-title-wrapper">
            <div className="fields-data-header-title">
              <span>
                <FontAwesomeIcon
                  icon={["far", "check-circle"]}
                  color="#02AB31"
                />
              </span>{" "}
              Query successful
            </div>
            {this.props.dataSourceSelected !== "csv" && (
              <div className="fields-data-header-subtitle">
                <span>
                  {`These are the opportunity data’s that got synced from ${dataSource.label} for the
   selected date period of`}
                </span>{" "}
                <span>
                  <strong>{`${startDate} - ${endDate}`}</strong>
                </span>{" "}
                <span
                  data-test="fields-data-header-subtitle-date"
                  className="fields-data-header-change-date"
                  onClick={this.props.handleDateFilterPopup}
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex="0">
                  Change Period
                </span>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default FieldsDataHeader;
